/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2023 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import {placeListErrors} from "./front/_front";

export function navigation(){
    if($('.js-categoryBox').length ){
        $(document).on('click', '.js-categoryBox', function (e){
            e.preventDefault();
            e.stopPropagation();

            const _job = $(this).attr('data-job');
            if(typeof _job != 'undefined'){
                window.Job = jQuery.parseJSON(_job);

                const data = [{name: "id_afpw_job_type", value: window.Job.id_afpw_job_type}];
                getJobTypeValues(data);
            }

        });
    }
}
function getJobTypeValues(data){

    $.ajax({
        method: "POST",
        url: afpw_ajax_url,
        beforeSend: function () {
            $('#content').html('<div class="kx-loader"></div>');
        },
        cache: false,
        data: {
            ajax: true,
            action: 'getJobTypeValues',
            hash: afpw_hash,
            data: $.param(data)
        },
    }).done(function (data, textStatus, jqXHR){
        try {
            var obj = jQuery.parseJSON(data);
            if (obj.status == 'success') {
                $('#content').html(obj.html);
                $('.js-jobUnits-title').html(window.Job.name);
                $('.js-jobUnits-small-description').html(window.Job.description_small_listing);
            } else {
                $('#content').html('<div class="alert alert-danger" role="alert">Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα</div>')
                if (typeof(obj.errors) != 'undefined' ) {
                    $.each(obj.errors, function(key,value) {
                        $('#content').append('<div class="alert alert-danger" role="alert">'+ value +'</div>');
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }
    }).fail(function(jqXHR, textStatus, errorThrown) {
        placeListErrors('Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα');
        console.log(errorThrown);
    }).always(function() {

    });
}

